import { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

export default function Tabs({ tabs }) {
  const [activeIndex, setActiveIndex] = useState(0);

  if (!tabs || tabs.length === 0) {
    return <div>Nessuna tab disponibile.</div>;
  }

  return (
    <div className="w-full">
      {/* Header delle tabs */}
      <div className="flex -b mb-4 space-x-10">
        {tabs.map(({ label }, idx) => (
          <button
            key={idx}
            onClick={() => setActiveIndex(idx)}
            className={`px-4 py-2 -mb-px font-medium border-b-2 focus:outline-none  ${
              activeIndex === idx
                ? 'border-yellow-500 text-yellow-600'
                : 'border-gray-300 text-gray-500 hover:text-gray-700'
            }`}
          >
            {label}
          </button>
        ))}
      </div>

      {/* Contenuto con animazione */}
      <div className=" w-full min-h-[4rem]">
        <AnimatePresence exitBeforeEnter>
          <motion.div
            key={activeIndex}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -20 }}
            transition={{ duration: 0.3, ease: 'easeInOut' }}
            className=" inset-0 w-full"
          >
            {tabs[activeIndex].children}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
}
